export const BACKEND_URL =
  process.env.NX_PUBLIC_BACKEND_URL || window.location.origin;

export const TEAMS_APP_ID = process.env.NX_PUBLIC_TEAMS_APP_ID;

export const APP_REGISTRATION_ID = process.env.NX_PUBLIC_TEAMS_APP_REGISTRATION_ID;

export const TENANT_ID = process.env.NX_PUBLIC_TENANT_ID;
